import { Stack, Text, Title, Container, Image, Box } from "@mantine/core";
import GenericLogo from "@/components/Logos/GenericLogo";
import SmartWizLogo from "@/components/Logos/SmartWizLogo";
import creationHero from "@/assets/creation-hero.png";
import loginHero from "@/assets/login-hero.png";

interface HeaderSectionProps {
  businessInfo?: {
    logoUrl?: string;
    businessName?: string;
    message?: string;
    theme?: {
      primaryColor?: string;
    };
  };
  businessSlug?: string;
  lighterColor: string;
}

export const HeaderSection = ({
  businessInfo,
  businessSlug,
  lighterColor,
}: HeaderSectionProps) => {
  return (
    <Stack
      className="business-login-container"
      align="stretch"
      justify="start"
      style={{
        background: businessSlug
          ? `linear-gradient(180deg, rgba(240, 240, 240, 0.5) 30%, ${businessInfo?.theme?.primaryColor ? lighterColor : "#0077CC"}80 100%)`
          : "linear-gradient(180deg,rgb(32, 54, 150) -10%, #0077cc 50%, #444ca0 100%)",
      }}
    >
      <div
        className="create-account-header-background"
        style={{
          height: "100%",
        }}
      >
        <Stack align="center" justify="center" gap={20} h="100%">
          <div>
            {businessInfo?.logoUrl ? (
              <Image
                src={businessInfo?.logoUrl}
                alt="Business Logo"
                height={96}
                width={96}
                radius="md"
                onError={(e) => {
                  const imgElement = e.target as HTMLImageElement;
                  console.error("Error loading business logo:", {
                    src: imgElement.src,
                    error: e,
                    businessInfo,
                  });
                }}
                fit="contain"
              />
            ) : businessSlug ? (
              <GenericLogo
                color={businessInfo?.theme?.primaryColor || "#0077CC"}
                width={72}
                height={72}
              />
            ) : (
              <SmartWizLogo
                isSmall={true}
                color={businessSlug ? "black" : "white"}
              />
            )}
          </div>
          <Container>
            {businessInfo?.businessName && (
              <Text ta="center" fw={700} size="lg">
                Welcome to
              </Text>
            )}
            <Title
              ta="center"
              order={1}
              textWrap="pretty"
              className="create-account-title"
              style={{
                fontSize: "2.5rem",
                maxWidth: "600px",
              }}
              c={businessSlug ? "black" : "white"}
            >
              {businessInfo?.businessName
                ? businessInfo.businessName
                : businessSlug
                  ? "Let's Get Your Taxes Done Right"
                  : "One Click is All It Takes"}
            </Title>
            {!businessSlug && (
              <Text ta="center" c="white" fw={400}>
                The smarter way to prepare taxes with ground-breaking
                innovation.
              </Text>
            )}
          </Container>
          {businessSlug && (
            <Container size="350px" px={8} className="create-account-message">
              <Text
                ta="center"
                fw={600}
                c={businessSlug ? businessInfo?.theme?.primaryColor : "#303030"}
              >
                {businessInfo?.message
                  ? businessInfo.message
                  : "Welcome to your dashboard! We are excited to get you started. Please fill out the form to create your account."}
              </Text>
            </Container>
          )}
          <Box w="100%" h="100%" p={48}>
            {businessSlug ? (
              <Image src={loginHero} alt="Login Image" width="100%" />
            ) : (
              <Image src={creationHero} alt="Creation Hero" width="100%" />
            )}
          </Box>
        </Stack>
      </div>
    </Stack>
  );
};
